import { useEffect } from 'react';

let id = 0;
let scrollOffset = 0;
const locks = new Set<typeof id>();

export type ScrollLock = {
  release(): void;
};

/**
 * Disable scrolling the page body
 */
export function useScrollLock(enabled = true): void {
  useEffect(() => {
    if (enabled) {
      return scrollLock().release;
    }
  }, [enabled]);
}

/**
 * Disable scrolling the page body until the lock is released
 */
export function scrollLock(): ScrollLock {
  const isIOS =
    typeof window === 'undefined' ||
    /^iP/.test(navigator.platform) ||
    // eslint-disable-next-line compat/compat -- used as feature detection
    (/^Mac/.test(navigator.platform) && navigator.maxTouchPoints > 4);
  const current = id++;
  locks.add(current);
  if (locks.size === 1) {
    // Add padding to avoid reflow when the scrollbar disappears
    const scrollBarWidth = document.scrollingElement
      ? window.innerWidth - document.scrollingElement.clientWidth
      : 0;
    document.body.style.paddingRight = `${scrollBarWidth}px`;
    document.body.classList.add('overflow-hidden');
    if (isIOS) {
      scrollOffset = window.pageYOffset;
      document.body.classList.add('fixed');
      document.body.style.top = `-${scrollOffset}px`;
    }
  }
  return {
    release() {
      locks.delete(current);
      if (locks.size === 0) {
        document.body.classList.remove('overflow-hidden');
        document.body.style.paddingRight = '0';
        if (isIOS) {
          document.body.classList.remove('fixed');
          document.body.style.top = ``;
          window.scrollTo(0, scrollOffset);
        }
      }
    },
  };
}
